import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { acoes, routes } from '../../../constants'
import { actions } from '../lancamento-pagamentos.actions'
import { LancamentoPagamentoForm } from './LancamentoPagamentoForm'
import utils from '../../../utils/index'
import storage from '../../../services/stoage.service'
import '../../../index.scss'
import './LancamentoForm.scss'
import _ from 'lodash'
import {
  mapDispatchToPropsLancamentoPagamentos,
  mapStateToPropsLancamentoPagamentos,
  fuBeforeFetchRecordSuccess,
  fuOnResponseGetPacoteTaxas,
  fuOnBlurValorDescontoAcrescimo,
  fuCalcularValorTotal,
  fuComponentDidMount,
  fuComponentDidUpdate,
  fuCalcularValorParcela,
  fuAfterLoad,
  fuAfterNew,
  fuEditarNumeroParcelas,
  fuOnBlurValorFormaPagamento,
  fuOnBlurValorParcela,
  fuOnBlurNumeroParcelas,
  fuChangeHandlerValorLancamento,
  fuOnChangeJurosDia,
  fuOnChangeTipoDesconto,
  fuOnChangeValorDesconto,
  fuOnChangePercentualDesconto,
  fuOnChangeTipoMulta,
  fuOnChangeValorMulta,
  fuOnChangePercentualMulta,
  fuOnChangeTipoJuros,
  fuOnChangeValorJuros,
  fuOnChangePercentualJuros,
  fuOnBlurConspagaPagarAte,
  fuOnChangeHandlerConspagaPagarAte,
  fuChangeHandlerFormaPagamento,
  fuLookupPagadorOnPage,
  fuLookupPagadorOnSort,
  fuLookupPagadorOnFilter,
  fuLookupPagadorOnClick,
  fuLookupPagadorOnHide,
  fuSetFieldPagador,
  fuLookupPagadorOnConfirm,
  fuLookupPagadorOnCancel,
  fuLookupPagadorOnEdit,
  fuLookupPagadorOnInputFilter,
  fuCheckDocumentoPagador,
  fuLookupPagadorOnKeyPress,
  fuSetContrato,
  fuSetNotaEntrada,
  fuSetContaCorrente,
  fuHideDialog,
  fuRealizarBaixaLancamentosFilhos,
  fuRealizarBaixaLancamento,
  fuExecutarBaixaLancamento,
  fuVerificarGeracaoBoletoIndividual,
  fuEstornarLancamento,
  fuEnviarWhatsApp,
  fuGetBotoesPersonalizados,
  fuGerarBoletoIndividual,
  fuGerarCarneParcelas,
  fuGetModalBaixarLancamento,
  fuGetDialogDadosBaixaParcela,
  fuGetDialogCancelarReabrir,
  fuGetDialogDadosBoletoIndividual,
  fuGetDialogEstornar,
  fuGetDialogEstornarParcelas,
  fuGetDialogUnirLancamento,
  fuAtualizarProvisionamento,
  fuOnClickAdicionarParcela,
  fuOnClickBaixarLancamentos,
} from '../../../utils/lancamento-form-utils'
import {
  formActionPagamento,
  formColumnData,
  formColunasPagamento,
  fuAbrirLancamento,
  fuDesabilitarBotaoAdicionarPagamento,
  fuDesabilitarBotaoBaixarParcela,
  fuDesabilitarBotaoBoleto,
  fuDesabilitarBotaoCarne,
  fuDesabilitarBotaoEstornarParcela,
  fuGetValorLancamentosFilhos,
  fuOnChangeItemLancamento,
  fuSetMarcadores,
  fuShowFormParcelas,
} from '../../../utils/lancamento/form/form-render'

let self

const mapStateToProps = (state) => {
  return mapStateToPropsLancamentoPagamentos(state)
}
const mapDispatchToProps = (dispatch) => {
  return mapDispatchToPropsLancamentoPagamentos(dispatch)
}

class LancamentoPagamentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    this.state = {
      ACAO_CANCELAR_LANCAMENTOS: storage.getAcao(acoes.ACAO_CANCELAR_LANCAMENTOS),
      ACAO_UNIR_LANCAMENTOS: storage.getAcao(acoes.ACAO_UNIR_LANCAMENTOS),
      BLOQUEAR_LANCAMENTO: storage.getAcao(acoes.BLOQUEAR_LANCAMENTO),
      ESTORNAR_LANCAMENTO: storage.getAcao(acoes.ESTORNAR_LANCAMENTO),
      ACAO_EXIBIR_ABA_INTEGRACAO_LANCAMENTO: storage.getAcao(acoes.ACAO_EXIBIR_ABA_INTEGRACAO_LANCAMENTO),
      paramBaixarLancamento: {
        oidLancamento: '',
        valorPago: '',
        dataPagamento: '',
        formaPagamento: '',
      },
      activeIndex: 0,
      oidLancamentoUnir: '',
      showConfirmarEstornar: false,
      showDialogRemove: false,
      showConfirmarUnirLancamento: false,
      showConfirmarCancelarReabrir: false,
      showConfirmarEstornarParcelas: false,
      screenWidth: null,
    }

    this.lancamentoCancelarReabrir = null

    actions.carregarMensageria = (mensagem) => {
      props.history.push('/geral/cadastros/mensageria', { mensagem })
    }
    actions.beforeFetchRecordSuccess = (data) => {
      return fuBeforeFetchRecordSuccess(data)
    }

    actions.onResponseGetPacoteTaxas = (taxaSelecionada, pacoteTaxas) => {
      fuOnResponseGetPacoteTaxas(taxaSelecionada, pacoteTaxas, this)
    }
    actions.afterSave = (data) => {
      this.props.history.replace(`${routes.PATH_LANCAMENTO_FINANCEIRO_PAGAMENTOS}/${data.oid}`)
    }

    actions.afterNew = () => {
      fuAfterNew(this, routes.PATH_LANCAMENTO_FINANCEIRO_PAGAMENTOS)
    }

    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_LANCAMENTO_FINANCEIRO_PAGAMENTOS}`)
    }

    actions.afterLoad = () => {
      fuAfterLoad(this)
    }

    actions.afterGetDescontosMultasJuros = () => {
      this.props.showForm('baixarParcelas', true)
      fuGetDialogDadosBaixaParcela(this)
    }

    this.setField = props.setField
    self = this
  }

  componentDidMount() {
    fuComponentDidMount(this)
  }

  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions() {
    this.setState({ screenWidth: window.innerWidth })
  }

  componentDidUpdate(anteriorProps) {
    fuComponentDidUpdate(anteriorProps, this)
  }

  searchHandler = () => {
    this.props.newHandler()
    this.props.history.push(`${routes.PATH_LANCAMENTO_FINANCEIRO_PAGAMENTOS}`)
  }

  ordenarArrayParcelas = () => {
    let lancamentosOrdenados = utils.orderArrayByProperty(this.props.record.lancamentos, 'vencimento')
    if (!utils.isArrayNullOrEmpty(lancamentosOrdenados)) {
      this.props.setField('lancamentos', lancamentosOrdenados)
    }
  }

  onSelectionChange = (e) => {
    this.props.setSelectedParcelas(e.value)
  }

  editarNumeroParcelas = (e) => {
    fuEditarNumeroParcelas(e, this)
  }

  changeActiveIndex = (index) => {
    this.setState({ activeIndex: index })
  }

  //TODO - verificar se ainda e usado - alterado para ltsCurrency
  onBlurValorDescontoAcrescimo = (e) => {
    fuOnBlurValorDescontoAcrescimo(e, this)
  }

  onBlurValor = (e) => {
    fuCalcularValorParcela(this)
  }

  onBlurValorFormaPagamento = (lancamento, e) => {
    fuOnBlurValorFormaPagamento(lancamento, e, this)
  }

  onBlurValorParcela = (e) => {
    fuOnBlurValorParcela(e, this)
  }

  onBlurNumeroParcelas = (e) => {
    fuOnBlurNumeroParcelas(e, this)
  }

  //metodo chamado somennte ao alterar campos que impactem o valor;
  // TODO - verificar se ainda e usado
  changeHandlerValorLancamento = (e) => {
    fuChangeHandlerValorLancamento(e, this)
  }

  onChangeJurosDia = (e) => {
    fuOnChangeJurosDia(e, this)
  }

  recalcularValorLancamento = () => {
    setTimeout(() => {
      this.props.recalcularValorLancamento()
    }, 200)
  }

  onChangeTipoDesconto = (event) => {
    fuOnChangeTipoDesconto(event, this)
  }

  onChangeValorDesconto = (value) => {
    fuOnChangeValorDesconto(value, this)
  }

  onChangePercentualDesconto = (value) => {
    fuOnChangePercentualDesconto(value, this)
  }

  onChangeTipoMulta = (event) => {
    fuOnChangeTipoMulta(event, this)
  }

  onChangeValorMulta = (value) => {
    fuOnChangeValorMulta(value, this)
  }

  onChangePercentualMulta = (value) => {
    fuOnChangePercentualMulta(value, this)
  }

  onChangeTipoJuros = (event) => {
    fuOnChangeTipoJuros(event, this)
  }

  onChangeValorJuros = (value) => {
    fuOnChangeValorJuros(value, this)
  }

  onChangePercentualJuros = (value) => {
    fuOnChangePercentualJuros(value, this)
  }

  onBlurConspagaPagarAte = (e) => {
    fuOnBlurConspagaPagarAte(e, this)
  }

  onChangeHandlerConspagaPagarAte = (taxa, e) => {
    fuOnChangeHandlerConspagaPagarAte(taxa, e, this)
  }

  changeHandlerFormaPagamento = (event) => {
    fuChangeHandlerFormaPagamento(event, this)
  }

  calcularValorTotal = (valorBruto) => {
    return fuCalcularValorTotal(valorBruto, this)
  }

  //REFERENTE AO LOOKUP DE PAGADOR
  lookupPagadorOnPage = (e) => {
    fuLookupPagadorOnPage(e, this)
  }

  lookupPagadorOnSort = (e) => {
    fuLookupPagadorOnSort(e, this)
  }

  lookupPagadorOnFilter = (e) => {
    fuLookupPagadorOnFilter(e, this)
  }

  lookupPagadorOnClick = (e) => {
    fuLookupPagadorOnClick(e, this)
  }

  lookupPagadorOnHide = (e) => {
    fuLookupPagadorOnHide(e, this)
  }

  lookupPagadorOnConfirm = (e) => {
    fuLookupPagadorOnConfirm(e, this)
  }

  setFieldPagador = (oid, nome, numeroDocumento) => {
    fuSetFieldPagador(oid, nome, numeroDocumento, this)
  }

  checkDocumentoPagador = (value) => {
    fuCheckDocumentoPagador(value, this)
  }

  lookupPagadorOnCancel = (e) => {
    fuLookupPagadorOnCancel(e, this)
  }

  lookupPagadorOnEdit = () => {
    fuLookupPagadorOnEdit(this)
  }

  lookupPagadorOnComplete = (e) => {}

  lookupPagadorOnInputFilter = (e) => {
    fuLookupPagadorOnInputFilter(e, this)
  }

  lookupPagadorOnKeyPress = (e) => {
    fuLookupPagadorOnKeyPress(e, this)
  }

  // REFERENTE AO LOOKUP PARA CONTRATO
  setContrato = (data) => {
    fuSetContrato(data, this)
  }

  setNotaEntrada = (data) => {
    fuSetNotaEntrada(data, this)
  }

  setContaCorrente = (data) => {
    fuSetContaCorrente(data, this)
  }

  hideDialog = () => {
    fuHideDialog(this)
  }

  hideBotaoRemover = () => {
    return true
  }

  calcularValorParcela = () => {
    fuCalcularValorParcela(this)
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  realizarBaixaLancamentosFilhos = () => {
    fuRealizarBaixaLancamentosFilhos(this)
  }

  realizarBaixaLancamento = () => {
    fuRealizarBaixaLancamento(this)
  }

  executarBaixaLancamento = () => {
    fuExecutarBaixaLancamento(this)
  }

  verificarGeracaoBoletoIndividual = (lancamento) => {
    fuVerificarGeracaoBoletoIndividual(lancamento, this)
  }

  getBotoesPersonalizados = () => {
    return fuGetBotoesPersonalizados(this)
  }

  gerarBoletoIndividual = () => {
    fuGerarBoletoIndividual(this)
  }

  gerarCarneParcelas = () => {
    fuGerarCarneParcelas(this)
  }

  getValorReais = (valor) => {
    if (valor && valor !== '') {
      return 'R$ ' + valor
    }
    return ''
  }

  //TODO mover para baixar-lancamento-dialog.js
  onHideModalBaixarLancamento() {
    self.props.showForm('baixar', false)
  }

  //TODO mover para baixar-lancamento-dialog.js
  confirmarBaixa({ valor, data, formaPagamento, lancamentos }) {
    const oidsLancamentos = lancamentos.map((l) => l.oid)
    const params = {
      oidsLancamentos,
      valor,
      data,
      formaPagamento,
    }
    self.props.executarBaixaLancamentos(params)
    self.onHideModalBaixarLancamento()
  }

  abrirLancamento = (oidLancamento) => {
    fuAbrirLancamento(oidLancamento, this, routes.PATH_LANCAMENTO_FINANCEIRO_PAGAMENTOS)
  }

  desabilitarBotaoAdicionarPagamento = () => {
    return fuDesabilitarBotaoAdicionarPagamento(this)
  }

  desabilitarBotaoEstornarParcela = () => {
    return fuDesabilitarBotaoEstornarParcela(this)
  }

  desabilitarBotaoBaixarParcela = () => {
    return fuDesabilitarBotaoBaixarParcela(this)
  }

  desabilitarBotaoBoleto = () => {
    return fuDesabilitarBotaoBoleto(this)
  }

  desabilitarBotaoCarne = () => {
    return fuDesabilitarBotaoCarne(this)
  }

  estornarLancamento = (oidsLancamentos) => {
    fuEstornarLancamento(oidsLancamentos, this)
  }

  estornarParcelas = () => {
    this.setState({ showConfirmarEstornarParcelas: true })
  }

  getValorLancamentosFilhos = () => {
    return fuGetValorLancamentosFilhos(this)
  }

  disabledBotaoBoleto = (lancamento) => {
    return !(
      lancamento.oid &&
      lancamento.oid !== '' &&
      lancamento.tipoFormaPagamento &&
      lancamento.tipoFormaPagamento.id === 5
    )
  }

  onClickAdicionarParcela = () => {
    fuOnClickAdicionarParcela(this).then()
  }

  showFormParcelas = () => {
    fuShowFormParcelas(this)
  }

  onChangeItemLancamento = (data) => {
    fuOnChangeItemLancamento(data, this)
  }

  setMarcadores = (data) => {
    fuSetMarcadores(data, this)
  }

  enviarWhatsApp = (oidLancamento) => {
    fuEnviarWhatsApp(oidLancamento, this)
  }

  atualizarProvisionamento = () => {
    fuAtualizarProvisionamento(this.props.record, this)
  }

  onClickBaixarParcela = () => {
    fuOnClickBaixarLancamentos(this)
  }

  render() {
    const actionPagamento = (rowData) => {
      return formActionPagamento(rowData, this)
    }

    const columnData = (rowData, column) => {
      return formColumnData(rowData, column, this, routes.PATH_LANCAMENTO_FINANCEIRO_PAGAMENTOS)
    }

    const colunasPagamento = formColunasPagamento(this, columnData, actionPagamento)
    const content = (
      <div>
        {fuGetModalBaixarLancamento(this)}
        {fuGetDialogDadosBaixaParcela(this)}
        {fuGetDialogCancelarReabrir(this)}
        {fuGetDialogDadosBoletoIndividual(this)}
        {fuGetDialogEstornar(this)}
        {fuGetDialogEstornarParcelas(this)}
        {fuGetDialogUnirLancamento(this)}
        <LancamentoPagamentoForm
          state={this.state}
          changeActiveIndex={this.changeActiveIndex}
          pagamento={this.props.pagamento}
          editarDadoFormaPagamento={this.props.editarDadoFormaPagamento}
          adicionarPagamento={this.props.adicionarPagamento}
          colunasPagamentos={colunasPagamento}
          disableUnit={this.props.disableUnit}
          unidades={this.props.unidades}
          currentUser={this.props.currentUser}
          messages={this.props.messages}
          status={this.props.status}
          changeHandler={this.props.changeHandler}
          changeHandlerFormaPagamento={this.changeHandlerFormaPagamento}
          getValorLancamentosFilhos={this.getValorLancamentosFilhos}
          editarNumeroParcelas={this.editarNumeroParcelas}
          estornarPagamento={this.estornarParcelas}
          desabilitarBotaoAdicionarPagamento={this.desabilitarBotaoAdicionarPagamento}
          desabilitarBotaoEstornarParcela={this.desabilitarBotaoEstornarParcela}
          desabilitarBotaoBaixarParcela={this.desabilitarBotaoBaixarParcela}
          desabilitarBotaoBoleto={this.desabilitarBotaoBoleto}
          desabilitarBotaoCarne={this.desabilitarBotaoCarne}
          gerarCarneParcelas={this.gerarCarneParcelas}
          onBlurValor={this.onBlurValor}
          onBlurValorFormaPagamento={this.onBlurValorFormaPagamento}
          onBlurValorParcela={this.onBlurValorParcela}
          onBlurValorDescontoAcrescimo={this.onBlurValorDescontoAcrescimo}
          calcularValorParcela={this.calcularValorParcela}
          clearFormPagamento={this.props.clearFormPagamento}
          onBlurNumeroParcelas={this.onBlurNumeroParcelas}
          calcularValorTotal={this.calcularValorTotal}
          changeHandlerValorLancamento={this.changeHandlerValorLancamento}
          onChangeValorDesconto={this.onChangeValorDesconto}
          onChangePercentualDesconto={this.onChangePercentualDesconto}
          onChangeTipoDesconto={this.onChangeTipoDesconto}
          onChangeValorMulta={this.onChangeValorMulta}
          onChangePercentualMulta={this.onChangePercentualMulta}
          onChangeTipoMulta={this.onChangeTipoMulta}
          onChangeValorJuros={this.onChangeValorJuros}
          onChangePercentualJuros={this.onChangePercentualJuros}
          onChangeTipoJuros={this.onChangeTipoJuros}
          onChangeJurosDia={this.onChangeJurosDia}
          displayForm={this.props.displayForm}
          showForm={this.props.showForm}
          showFormParcelas={this.showFormParcelas}
          onClickAdicionarParcela={this.onClickAdicionarParcela}
          record={this.props.record}
          onSelectionChange={this.onSelectionChange}
          selectedParcelas={this.props.selectedParcelas}
          abrirLancamento={this.abrirLancamento}
          history={this.props.history}
          onChangeHandlerConspagaPagarAte={this.onChangeHandlerConspagaPagarAte}
          onBlurConspagaPagarAte={this.onBlurConspagaPagarAte}
          //------
          lookupPagador={this.props.lookupPagador}
          lookupPagadorOnKeyPress={this.lookupPagadorOnKeyPress}
          lookupPagadorOnHide={this.lookupPagadorOnHide}
          lookupPagadorOnConfirm={this.lookupPagadorOnConfirm}
          lookupPagadorOnCancel={this.lookupPagadorOnCancel}
          lookupPagadorOnPage={this.lookupPagadorOnPage}
          lookupPagadorOnSort={this.lookupPagadorOnSort}
          lookupPagadorOnFilter={this.lookupPagadorOnFilter}
          lookupPagadorOnClick={this.lookupPagadorOnClick}
          lookupPagadorOnEdit={this.lookupPagadorOnEdit}
          lookupPagadorOnComplete={this.lookupPagadorOnComplete}
          lookupPagadorOnInputFilter={this.lookupPagadorOnInputFilter}
          //-----
          setContrato={this.setContrato}
          formasPagamento={this.props.formasPagamento}
          formasPagamentoBasica={this.props.formasPagamentoBasica}
          setField={this.props.setField}
          servicoCartaoCreditoVindi={this.props.servicoCartaoCreditoVindi}
          servicoBoletoVindi={this.props.servicoBoletoVindi}
          onChangeItemLancamento={this.onChangeItemLancamento}
          showMessageConspagaEmDia={this.props.showMessageConspagaEmDia}
          fatorMultiplicadorConspaga={this.props.fatorMultiplicadorConspaga}
          units={_.get(this, 'props.units', storage.getUnits())}
          currentCompany={_.get(this, 'props.currentCompany', storage.getCompany())}
          showWarningMessage={this.props.showWarningMessage}
          exibirConspaga={this.props.exibirConspaga}
          setFieldPagador={this.setFieldPagador}
          checkDocumentoPagador={this.checkDocumentoPagador}
          statePessoaFisica={this.props.statePessoaFisica}
          statePessoaJuridica={this.props.statePessoaJuridica}
          cartoesPagador={this.props.cartoesPagador}
          setMarcadores={this.setMarcadores}
          stateMarcador={this.props.stateMarcador}
          setNotaEntrada={this.setNotaEntrada}
          stateNotaEntrada={this.props.stateNotaEntrada}
          setContaCorrente={this.setContaCorrente}
          formaPagamentoOriginal={this.props.formaPagamentoOriginal}
          emiteNFSe={this.props.emiteNFSe}
          descontoAplicado={this.props.descontoAplicado}
          multaAplicada={this.props.multaAplicada}
          jurosAplicados={this.props.jurosAplicados}
          adicionandoAnexo={this.props.adicionandoAnexo}
          anexos={this.props.record.anexos}
          onSelectAnexo={this.props.addAnexo}
          downloadAnexo={this.props.downloadAnexo}
          removeAnexo={this.props.removeAnexo}
          acaoBloquearLancamento={this.state.BLOQUEAR_LANCAMENTO}
          acaoExibirAbaIntegracaoLancamento={this.state.ACAO_EXIBIR_ABA_INTEGRACAO_LANCAMENTO}
          atualizarProvisionamento={this.atualizarProvisionamento}
          onClickBaixarParcela={this.onClickBaixarParcela}
        />
      </div>
    )
    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LancamentoPagamentoFormPageContainer)
